import { render } from "./CDropdown.vue?vue&type=template&id=50ab06fa&scoped=true&ts=true"
import script from "./CDropdown.vue?vue&type=script&lang=ts"
export * from "./CDropdown.vue?vue&type=script&lang=ts"

import "./CDropdown.vue?vue&type=style&index=0&id=50ab06fa&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50ab06fa"]])

export default __exports__